














import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import * as _ from "lodash";
import { inventoryCollection, tagsCollection } from "../db";
import * as firebase from "firebase/app";

@Component({})
export default class EquipmentTagEdit extends Vue {
  @Getter tags;

  @Prop({ required: true })
  public item: any;

  @Prop({ required: true })
  public label: any;

  @Prop({ required: true })
  public value: any;

  private oldItemTags: Array<any> = [];

  @Watch("item.tags", { immediate: true })
  async watchItemTags() {
    this.oldItemTags = [];
    if (Array.isArray(this.item.tags)) {
      this.item.tags.forEach((t) => {
        this.oldItemTags.push({ id: t.id });
      });
    }
  }

  async change(itemTags) {
    const obj = {};
    if (itemTags.length > this.oldItemTags.length) {
      const add = _.differenceBy(itemTags, this.oldItemTags, "id") as Array<any>;
      obj[this.value] = firebase.firestore.FieldValue.arrayUnion(
        tagsCollection.doc(add[0].id)
      );
    } else if (this.oldItemTags.length > itemTags.length) {
      const remove = _.differenceBy(this.oldItemTags, itemTags, "id");
      obj[this.value] = firebase.firestore.FieldValue.arrayRemove(
        tagsCollection.doc(remove[0].id)
      );
    }
    await inventoryCollection.doc(this.item.id).update(obj);
  }
}
